import styled from "styled-components";
import { media } from "../../../theme/theme";
import { MarketingLinkHoverEffect } from "../../ReusableStyledComponents/MarketingLinkHover";
import { Body, H1, H4 } from "../../Typography";

export const NavigationUseCaseWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    > div {
        display: inline-flex;
        margin-right: 8px;
        
        &:nth-child(3) {
            margin-top: 5px;
        }
    }
`;

export const UseCaseSlideWrapperTwo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
        &:first-child {
            max-width: 350px;
            padding: 5px 0;
            
            ${media.tablet} {
                padding: 35px;
                margin-right: 20px;
            }
        }

        &:nth-child(2) {
            display: none;
            max-width: 600px;

            ${media.tablet} {
                display: block;
            }

            img {
                width: 100%;
                height: auto;
            }
        }
    }

    ${H4} {
        line-height: 32px;
        color: ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};
    }

    ${MarketingLinkHoverEffect}
        
    a {
        text-decoration: none;
        color: ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};

        &:hover {
            ${H4} {
                color: ${({ theme }) => theme ? theme.marketing.colors.chathamsBlue : null};
            }
        }
    }
`;

export const UseCaseSlideTestimonialWrapper = styled.div`
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.17), 0px 1px 6px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    text-align: center;
    padding: 18px 27px 41px;
`;

export const UseCaseSlideBody = styled(Body)`
    color:  ${({ theme }) => theme ? `${theme.marketing.colors.blackPearl80}` : null};
`;

export const UseCaseSlideBodyQuote = styled(UseCaseSlideBody)`
    font-style: italic;
`;

export const UseCaseSlideBodyQuotationMark = styled(H1)`
    line-height: 42px;
`;